import React, { Component } from 'react'
import { reduxForm, formValueSelector } from 'redux-form'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { getTemplateBrandingState } from 'ducks/apps'
import { fetchOrganizations, getOrganizations } from 'ducks/organizations'
import { defaultBranding } from 'utils/colors'
import { createApp } from 'utils/io'
import Stepper from 'components/Shared/Stepper'

import WizardFormPlatformPage from './WizardFormPlatformPage'
import WizardFormBrandingPage from './WizardFormBrandingPage'
import WizardFormAdvancedPage from './WizardFormAdvancedPage'
import './NewApp.css'
import { FORM_NAME } from './shared'
import WizardFormTemplatesPage from './WizardFormTemplatesPage'

class WizardForm extends Component {
  static propTypes = {
    organizations: PropTypes.arrayOf(PropTypes.object).isRequired,
    fetchOrganizations: PropTypes.func.isRequired,
  }

  state = {
    page: 1,
  }

  componentDidMount() {
    const { fetchOrganizations } = this.props
    fetchOrganizations()
  }

  handleNextPage = () => {
    this.setState(state => ({ page: state.page + 1 }))
  }

  handlePreviousPage = () => {
    this.setState(state => ({ page: state.page - 1 }))
  }

  handleOpenAdvanced = () => {
    this.setState({ page: 'advanced' })
  }

  handleSubmitAdvanced = () => {
    this.setState({ page: 3 })
  }

  handleFinalSubmit = ({ primaryColor, secondaryColor, ...data }) => {
    const { organizations } = this.props

    data.datasourceAppId =
      data.datasourceType === 'copy' ? data.datasourceAppId : undefined

    data.branding = {
      ...defaultBranding,
      primary: primaryColor,
      secondary: secondaryColor,
    }

    if (!data.organizationId) {
      data.organizationId = organizations[0] && organizations[0].id
    }

    if (!data.organizationId) {
      return window.alert('Error: You are not part of any teams')
    }

    return createApp(data)
  }

  renderStepper() {
    const { page } = this.state

    if (page === 'advanced') {
      return null
    }

    return (
      <Stepper
        steps={['Platform', 'Template', 'Branding']}
        currentStep={page - 1}
      />
    )
  }

  render() {
    const { branding } = this.props
    const { page } = this.state

    const initialValues = {
      datasourceType: 'database',
      primaryColor: branding && branding.primary,
      secondaryColor: branding && branding.secondary,
    }

    return (
      <>
        {this.renderStepper()}
        {page === 1 && (
          <WizardFormPlatformPage
            initialValues={initialValues}
            onSubmit={this.handleNextPage}
          />
        )}
        {page === 2 && (
          <WizardFormTemplatesPage
            handlePreviousPage={this.handlePreviousPage}
            initialValues={initialValues}
            onSubmit={this.handleNextPage}
          />
        )}
        {page === 3 && (
          <WizardFormBrandingPage
            handlePreviousPage={this.handlePreviousPage}
            initialValues={initialValues}
            onOpenAdvanced={this.handleOpenAdvanced}
            onSubmit={this.handleFinalSubmit}
          />
        )}
        {page === 'advanced' && (
          <WizardFormAdvancedPage
            initialValues={initialValues}
            onSubmit={this.handleSubmitAdvanced}
          />
        )}
        <WizardFormDestroyer />
      </>
    )
  }
}

const WizardFormDestroyer = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: true,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(() => null)

const mapStateToProps = state => {
  const selector = formValueSelector(FORM_NAME)
  const templateId = selector(state, 'templateId')

  const branding =
    templateId === 'blank'
      ? defaultBranding
      : getTemplateBrandingState(state, templateId).branding

  return {
    organizations: getOrganizations(state),
    templateId,
    branding,
  }
}

const mapDispatchToProps = {
  fetchOrganizations,
}

export default connect(mapStateToProps, mapDispatchToProps)(WizardForm)
